
<div class="progress-modal-wrapper">
	<div class="bg-transparent flex flex-col justify-center items-center vertically-centralized">
		<div class="h-[54px] w-[55px] flex flex-wrap relative">
			<div class="flex flex-wrap p-[12px] w-full h-full">
				<svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg" width="54" height="53" viewBox="0 0 54 53" fill="none">
					<path d="M38.2141 28.4456L37.2741 16.9961H31.6045C31.6045 16.9961 27.2863 25.8102 26.9044 27.0107H26.8457L22.2924 16.9961H16.5935L15.6535 26.9229L14.8604 36.9961H18.3267C19.8249 36.9961 20.4124 36.3519 20.5299 34.7706C20.5299 34.7706 21.1174 25.5466 21.0293 24.1996H21.088L21.2643 24.8145C21.4993 25.6345 24.7306 33.5115 24.7306 33.5115H28.9901C28.9901 33.5115 32.2214 25.7516 32.6327 24.1996H32.6914L33.1908 34.7706C33.3083 36.3519 33.9252 36.9961 35.394 36.9961H38.8603L38.2141 28.4456Z" fill="white"/>
					<path d="M53.8564 26.5C53.8564 41.1334 41.9937 52.9961 27.3604 52.9961C12.727 52.9961 0.864258 41.1334 0.864258 26.5C0.864258 11.8666 12.727 0.00390625 27.3604 0.00390625C41.9937 0.00390625 53.8564 11.8666 53.8564 26.5ZM4.57371 26.5C4.57371 39.0847 14.7756 49.2866 27.3604 49.2866C39.9451 49.2866 50.147 39.0847 50.147 26.5C50.147 13.9153 39.9451 3.71336 27.3604 3.71336C14.7756 3.71336 4.57371 13.9153 4.57371 26.5Z" fill="white" fill-opacity="0.2"/>
				</svg>
			</div>
			<svg class="spinner col-span-full row-span-full" viewBox="0 0 38 38">
				<circle class="path" cx="19" cy="19" r="14" fill="none" stroke-width="3"></circle>
			</svg>
		</div>
		<p class="text-[12px] font-semibold leading-[140%] text-center text-white lg:text-[16px] lg:text-white">
			<ng-container *ngIf="!useExtraDescription else descriptionWithExtraDescription">
				{{description}}
			</ng-container>
		</p>
	</div>
</div>

<ng-template #descriptionWithExtraDescription>
	{{description}}, <br />
	{{extraDescription}}
</ng-template>
